/**
 *@author chenli
 *联动
 */
import Component from '../../../lib/component'
import template from './add-linkage.html'
import './add-linkage.scss'
import {FormService} from "../../../services/formService/formService";
import msgbox from "../../../lib/msgbox";
import Mediator from "../../../lib/mediator";

let config={
    template:template,
    data:{
      choosed_linkage:{}
    },
    actions:{
        //初始化拼接联动数据
        init(){
            this.data.choosed_linkage = {};
            this.data.new_data.forEach(item=>{
                this.data.choosed_linkage[item.value] = {};
                item.new_linkage_data.forEach(lk=>{
                    this.data.choosed_linkage[item.value][lk.dfield] = [];
                })
            })
        },
        //提交联动数据
        async postData(){
            let fields = [this.data.dfield].concat(this.data.fields);
            let json = {
                table_id:window.config.table_id,
                field_id:this.data.dfield,
                linkage:JSON.stringify(this.data.choosed_linkage),
                fields:JSON.stringify(fields),
            }
            let res = await FormService.saveEnumRrelation(json);
            if(res.success === 1) {
                //数据提交成功,通知form刷新
                let data = {
                    linkage:res.linkage,
                    dfield:this.data.dfield,
                }
                Mediator.publish('remind-form:add-linkage-success',data || {});
                AddLinkageControl.hide();
            }else {
                msgbox.alert(res.error);
            }
        }
    },
    binds:[
        {
            event: 'click',
            selector: '#submit',
            callback: function(){
                this.actions.postData();
            }
        },
        {
            event: 'click',
            selector: 'input[type=checkbox]',
            callback: function(e){
                let choosed = $(e).attr('value');
                let td1 = $(e).parents('td').siblings('td');
                let field_id = td1.attr('field_id');
                let id = td1.parents('li').attr('id');
                if(e.checked) {
                    this.data.choosed_linkage[id][field_id].push(choosed);
                }else {
                    this.data.choosed_linkage[id][field_id] = this.data.choosed_linkage[id][field_id].filter(item=>{
                        return item != choosed
                    })
                }
            }
        },
    ],
    afterRender(){
        this.actions.init();
    },
    beforeDestory(){
        this.el.off();
    }
}
let LinkageControl = Component.extend(config);

export const AddLinkageControl = {
    el:null,
    show: function(config={}) {
        let component = new LinkageControl(config);
        let w = window.screen.width * 0.6;
        let h = window.screen.height * 0.6;
        this.el = $('<div>').appendTo(document.body);
        component.render(this.el);
        this.el.erdsDialog({
            title: '联动数据',
            width:w || 800,
            modal:true,
            height: 580,
            close: function() {
                $(this).erdsDialog('destroy');
                component.destroySelf();
            }
        });
    },
    hide:function () {
        this.el.erdsDialog('close');
    }
};


// WEBPACK FOOTER //
// app/components/form/add-linkage/add-linkage.js